const actionTypes = {
  RECEIVE_LEADERBOARD: "seneca/classLeaderboards/RECEIVE_LEADERBOARD"
};

export default actionTypes;
